import { LogoutContainer, Content } from "./style";
import { useNavigate } from "react-router-dom";
import BackProfileButtonComp from "../BackProfileButtonComp";
import { useState, useEffect } from "react";
import axios from "axios";

interface LogoutOptionProps {
  closeLogout: () => void;
}

const LogoutOption = ({ closeLogout }: LogoutOptionProps) => {
 const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const [avatar, setAvatar] = useState("");
  const [name, setName] = useState("");
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/getme`, {
        headers: Authorization,
      })
      .then((res: any) => {
        if (res.data.result.image !== "") {
          setAvatar(res.data.result.image);
        } else {
          setAvatar("image/hush-logo.png");
        }
        if (res.data.result.firstname && res.data.result.lastname !== "") {
          setName(res.data.result.firstname + " " + res.data.result.lastname);
        } else if (res.data.result.username !== "") {
          setName(res.data.result.username);
        } else {
          setName("Pls update name");
        }
      })
      .catch((err) => {
        if (err && err.response.status === 409) {
          navigate("/login");
        } else {
        }
      });
  }, [Authorization, navigate]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <LogoutContainer>
        <BackProfileButtonComp
          title="logout"
          closeFunction={closeLogout}
        />
        <Content>
          <div>
            <img src={avatar} alt="profile-pic" />
            <span>{name}</span>
          </div>
          <div>Are you certain you want to log out of your account?</div>
          <div>
            <button onClick={closeLogout}>No</button>
            <button onClick={handleLogout}>Yes</button>
          </div>
        </Content>
      </LogoutContainer>
    </>
  );
};

export default LogoutOption;
